import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Hero.module.css';

const Hero: React.FC = () => {
  return (
    <section
      className={styles.hero}
      id="accueil"
      style={{
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.3) 60%, rgba(0,0,0,0) 100%), url(/assets/backgrounds/hero-bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center right',
      }}
    >
      <div className={styles.headerContent}>
        <h1 className={styles.title}>BRANDS2BUYERS</h1>
        <p className={styles.subtitle}>The Premier B2B Commerce Event</p>

        <div className={styles.descriptionBox}>
          <p className={styles.descriptionText}>
            Rejoignez-nous le <strong>25 Juin 2026</strong> en format afterwork à
            Paris pour <strong>Brands2Buyers</strong>, l'événement majeur en France
            dédié à la transformation digitale et à l'innovation dans le commerce
            B2B.
          </p>
        </div>

        <Link to="/inscriptions" className={styles.ctaButton}>
          S'INSCRIRE À B2B
        </Link>
      </div>
    </section>
  );
};

export default Hero;
